export const articleDetails = {
  1: {
    id: 1,
    title: '《流浪地球3》—— 国产科幻的新里程碑',
    category: '电影',
    categorySlug: 'movie',
    author: '影评人老王',
    publishDate: '2026-08-01',
    rating: 9.2,
    coverImage: 'https://readdy.ai/api/search-image?query=epic%20cinematic%20sci-fi%20scene%20with%20futuristic%20city%20and%20giant%20space%20station%2C%20dramatic%20orange%20sunset%20atmosphere%2C%20film%20scene%20aesthetic%2C%20grand%20scale%20composition%2C%20Chinese%20science%20fiction&width=1200&height=600&seq=article-01-cover&orientation=landscape',
    summary: '《流浪地球3》延续了前作的宏大世界观，在视觉效果和剧情深度上都达到了新的高度。本片不仅展现了更加震撼的太空场景，更深入探讨了人类在面临生存危机时的选择与牺牲。',
    content: [
      { type: 'heading', text: '剧情简介' },
      { type: 'paragraph', text: '在太阳急速衰老膨胀的背景下，地球联合政府启动了"流浪地球计划"的第三阶段。随着地球逐渐远离太阳系，人类面临前所未有的挑战——来自外太空的未知威胁与地球内部的社会动荡同时爆发。' },
      { type: 'paragraph', text: '刘培强（吴京 饰）带领的太空任务小组发现了一颗神秘的流浪行星，其上隐藏着可能改变人类命运的秘密。与此同时，地球上的科学家们也在争分夺秒地研究新的能源技术，以确保地球推进器的持续运转。' },
      { type: 'heading', text: '视觉特效全面升级' },
      { type: 'paragraph', text: '本片在视觉效果上实现了质的飞跃。太空场景的渲染精度相比前作提升了三倍，行星发动机的细节刻画更加逼真。特别值得一提的是影片中对"流浪行星"的呈现——这颗由特效团队耗时18个月打造的神秘星球，其表面的地质结构和光影效果堪称艺术品。' },
      { type: 'paragraph', text: '导演郭帆在接受采访时表示："我们希望《流浪地球3》不仅仅是一部科幻电影，更是一次对人类命运的深刻思考。技术永远是为故事服务的，这次我们在保持视觉震撼的同时，更加注重情感的传达。"' },
      { type: 'heading', text: '演员阵容与表演' },
      { type: 'paragraph', text: '吴京再次贡献了令人信服的表演，他将刘培强这个角色从一名普通宇航员到人类命运承担者的转变演绎得淋漓尽致。新加入的李雪健老师饰演的地球联合政府主席，以其沉稳有力的表演为影片增添了厚重的质感。' },
      { type: 'paragraph', text: '年轻演员方面，赵今麦和张子枫的表现同样令人惊喜，她们代表了新一代中国演员的崛起力量。' },
      { type: 'heading', text: '观影建议' },
      { type: 'paragraph', text: '建议选择IMAX或杜比影院观看，以获得最佳的视听体验。影片时长约160分钟，建议观影前做好准备。本片适合全家观看，但部分太空场景可能对低龄儿童造成轻微不适，建议家长陪同。' },
    ],
    relatedArticles: [2, 104, 205],
    tags: ['科幻', '国产大片', '流浪地球', '吴京', '郭帆'],
  },
  2: {
    id: 2,
    title: '《庆余年3》重磅回归，权谋升级再掀波澜',
    category: '电视剧',
    categorySlug: 'tv',
    author: '剧评人小李',
    publishDate: '2026-07-28',
    rating: 9.5,
    coverImage: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20palace%20drama%20scene%2C%20grand%20throne%20room%20with%20golden%20decorations%2C%20dramatic%20lighting%20with%20shadows%2C%20historical%20costume%20drama%20aesthetic%2C%20epic%20cinematic%20composition&width=1200&height=600&seq=article-02-cover&orientation=landscape',
    summary: '时隔两年，《庆余年》第三季终于与观众见面。范闲的命运将走向何方？陈萍萍的真实目的究竟是什么？所有的谜团将在这一季中逐一揭晓。',
    content: [
      { type: 'heading', text: '剧情走向' },
      { type: 'paragraph', text: '第三季的故事紧接上一季结尾，范闲在北齐的遭遇让他对庆国的政治格局有了更深刻的认识。回到京都后，他发现自己已经卷入了一场更大的权力漩涡之中。' },
      { type: 'paragraph', text: '陈萍萍的真实身份和目的成为本季最大的悬念。随着剧情的推进，观众将看到这个角色更加复杂的内心世界，以及他与范闲之间亦敌亦友的关系。' },
      { type: 'heading', text: '制作水准再创新高' },
      { type: 'paragraph', text: '《庆余年3》的制作预算达到了国产剧的新高度。服化道的精美程度令人叹为观止，每一帧画面都如同一幅精美的古画。配乐方面，邀请了国际知名作曲家操刀，将中国古典音乐元素与现代管弦乐完美融合。' },
      { type: 'heading', text: '观众反响' },
      { type: 'paragraph', text: '自开播以来，《庆余年3》在各大平台的热度持续攀升。豆瓣评分稳定在9.5分以上，弹幕互动量突破历史记录。不少观众表示"每一集都不舍得快进"，"这才是国产剧应有的水准"。' },
    ],
    relatedArticles: [1, 201, 202],
    tags: ['古装', '权谋', '庆余年', '张若昀', '国产剧'],
  },
  3: {
    id: 3,
    title: '《乘风2026》—— 姐姐们的终极舞台',
    category: '综艺',
    categorySlug: 'variety',
    author: '娱乐记者小张',
    publishDate: '2026-07-25',
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=vibrant%20stage%20performance%20with%20multiple%20female%20performers%2C%20colorful%20concert%20lighting%2C%20grand%20music%20show%20atmosphere%2C%20energetic%20dance%20scene%2C%20entertainment%20variety%20show%20aesthetic&width=1200&height=600&seq=article-03-cover&orientation=landscape',
    summary: '《乘风2026》汇集了30位来自不同领域的优秀女性，她们用汗水和才华在舞台上绽放光芒。本季节目在赛制和舞台呈现上都做了全面升级。',
    content: [
      { type: 'heading', text: '全新赛制' },
      { type: 'paragraph', text: '本季《乘风》采用了全新的"联盟对战"赛制，30位姐姐被分为三大联盟，通过多轮公演角逐最终的女团席位。每一轮公演都有不同的主题和挑战，姐姐们需要在短时间内完成高强度的训练和创作。' },
      { type: 'heading', text: '舞台亮点' },
      { type: 'paragraph', text: '本季舞台设计堪称综艺节目的天花板。360度旋转舞台、全息投影技术、以及堪比演唱会的灯光音响配置，为观众带来了视听的双重享受。' },
    ],
    relatedArticles: [301, 302, 304],
    tags: ['综艺', '音乐', '女团', '乘风破浪', '舞台'],
  },
};

export type ArticleContent = {
  type: 'heading' | 'paragraph';
  text: string;
};